import * as React from 'react';
import { Typography, Box } from '@mui/material';
import EventCompletionInfoHeader from '../commons/EventCompletionInfoHeader';

interface IProps {
  title: string;
  detailReason?: string;
  closeDialog: () => void;
}

export default function QuarantineDialogMessage({ title, detailReason, closeDialog }: IProps) {
  return (<>
    <EventCompletionInfoHeader title={title} onClose={closeDialog} />
    <Box sx={{ m: 5 }}>
      {detailReason?.split('\n').map((reason, index) => (
        <Typography key={index + reason} variant="body1" sx={{ fontWeight: 'normal', fontSize: 20, textAlign: 'center', m: 1 }}>
          {reason}
        </Typography>
      ))}

    </Box>
  </>
  );
}
